import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { DATA_QUALITY_DETAIL_QUERY } from '../../../graphql.js'
import { Alert, Table, Button } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import '../Custom.css'
import { getData } from '../CustomUtils.js'
import ColumnHeadings from '../ColumnHeadings.js'
import ParameterValues from '../ParameterValues.js'
import ReportGrid from '../ReportGrid.js'
import { getTenant } from '../../../utils.js'
import LargeRowHandler from '../LargeRowHandler.js'
import ReportHeading from '../ReportHeading.js'
import { Link } from 'react-router-dom'

const DATA_QUALITY_DETAIL = gql(DATA_QUALITY_DETAIL_QUERY)

export default function DataQualityDetail({ location }) {
  console.log('DataQualityDetail rendered: ', location)

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const params = new URLSearchParams(location.search)
  const conditionId = params.get('in_condition_id')

  function detailLink(data) {
    return <Link to={`/object/${data}`} target='_blank'><Button color="primary" size="sm">Detail</Button></Link>
  }

  useEffect(() => {
    const inputs = { conditionId: conditionId }
    getData(null, DATA_QUALITY_DETAIL, 'dataQualityDetail', setResults, setGraphQLErrors, 'inputs', inputs)
  }, [conditionId])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    const csvUrl = `${process.env.REACT_APP_SERVER}/csv/${getTenant()}/custom/BosSci/dataQualityDetail/data_quality_detail.csv?inputs={"conditionId":"${conditionId}"}`
    const columnFormatters = [
      { columnNumber: 6, formatter: detailLink, align: 'center' }
    ]
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl} resultsLength={results.reportData.length} />
        </div>
        <Table bordered style={{backgroundColor: 'white', width: 'auto', minWidth: '900px', margin: 'auto'}} >
          <ReportHeading title={results.otherData.title} parameterValues={ParameterValues(results)} />
          <tbody>
            <ColumnHeadings results={results} />
            <ReportGrid results={results} columnFormatters={columnFormatters} />
          </tbody>
        </Table>
      </div>
    )
  }
}
